// Road Detection Utilities (GPS proximity path only)
import { Coordinates } from '../../../../types';
import type { Road } from '@/types/road';
import { calculatePointToLineSegmentDistanceSimple } from '@/utils/geolocation/distanceCalculation';
import { WIZARD_CONSTANTS } from '../types/constants/constants';

/**
 * Find the closest road to given coordinates
 */
export const findClosestRoad = (
  coords: Coordinates,
  roads: Road[]
): Road | null => {
  let closestRoad: Road | null = null;
  let shortestDistance = Infinity;

  roads.forEach((road) => {
    if (!road.geometry || !road.geometry.coordinates) return;

    const roadCoords = road.geometry.coordinates as [number, number][];

    for (let i = 0; i < roadCoords.length - 1; i++) {
      const startCoord = roadCoords[i];
      const endCoord = roadCoords[i + 1];
      if (!startCoord || !endCoord) continue;

      const start: Coordinates = {
        lat: startCoord[1],
        lng: startCoord[0],
      };
      const end: Coordinates = {
        lat: endCoord[1],
        lng: endCoord[0],
      };

      const distance = calculatePointToLineSegmentDistanceSimple(
        coords,
        start,
        end
      );
      if (distance < shortestDistance) {
        shortestDistance = distance;
        closestRoad = road;
      }
    }
  });

  return closestRoad;
};

/**
 * Generate cache key for road detection
 */
export const generateCacheKey = (coords: Coordinates): string => {
  const precision = WIZARD_CONSTANTS.CACHE_KEY_PRECISION;
  const multiplier = Math.pow(10, precision);
  const lat = Math.round(coords.lat * multiplier) / multiplier;
  const lng = Math.round(coords.lng * multiplier) / multiplier;
  return `road_${lat}_${lng}`;
};
